/**
 * @deprecated This file is kept for backward compatibility only.
 * All course data should be fetched from the database via UnifiedCourseService.
 * DO NOT ADD NEW COURSES HERE - use database migrations instead.
 */
// Azure course data placeholder - migrated from static to database-backed
import { useDatabaseCourseNavigation } from '@/hooks/useDatabaseCourseNavigation';

// Temporary mock data for backward compatibility
export const AZURE_COURSES: AzureCourse[] = [
  {
    id: 'azure-fundamentals',
    title: 'Azure Fundamentals',
    description: 'Learn the basics of Microsoft Azure cloud services',
    level: 'fundamentals',
    totalDuration: '8 hours',
    certification: {
      name: 'Azure Fundamentals',
      provider: 'Microsoft',
      exam_code: 'AZ-900',
      preparation_time: '2-4 weeks'
    },
    modules: [
      {
        id: 'azure-intro',
        title: 'Introduction to Azure',
        description: 'Get started with Azure cloud platform',
        content: 'Azure basics content...',
        duration: '2 hours',
        estimatedTime: '2 hours',
        order: 1,
        difficulty: 'beginner' as const,
        objectives: ['Understand Azure basics']
      }
    ],
    prerequisites: [],
    learningOutcomes: ['Understand Azure cloud platform']
  }
];

// Export types for backward compatibility
export interface AzureModule {
  id: string;
  title: string;
  description: string;
  content: string;
  duration: string;
  estimatedTime: string;
  order: number;
  difficulty: 'beginner' | 'intermediate' | 'advanced';
  objectives: string[];
  hands_on_labs?: Array<{
    title: string;
    description: string;
    estimated_time: string;
    steps: string[];
  }>;
  prerequisites?: string[];
  quiz?: {
    questions: Array<{
      id: string;
      question: string;
      options: string[];
      correctAnswer: number;
      explanation?: string;
      difficulty?: 'easy' | 'medium' | 'hard';
      points?: number;
      type?: 'multiple-choice' | 'true-false' | 'code-analysis' | 'scenario';
    }>;
    passThreshold?: number;
  };
}

export interface AzureCourse {
  id: string;
  title: string;
  description: string;
  level: string;
  totalDuration: string;
  modules: AzureModule[];
  prerequisites: string[];
  learningOutcomes: string[];
  certification?: {
    name: string;
    provider: string;
    exam_code: string;
    preparation_time: string;
  };
}